<script setup lang="ts">
import { BaseEmptyState, BaseIcon } from '@magma-app/magma-lapilli';
</script>

<template>
  <section
    class="mx-auto w-full max-w-[760px] px-4 pb-10 pt-6 md:px-8 md:pb-12 lg:pt-8"
    aria-labelledby="relations-zero-state-title"
    data-cy="relations-zero-state"
  >
    <BaseEmptyState type="awaiting-match">
      <template #content>
        <h3
          id="relations-zero-state-title"
          class="text-mgm-txt-lg font-semibold text-foreground-emphasis"
        >
          {{ $t('relationsLayout.emptyState.title') }}
        </h3>
        <p
          class="mx-auto mt-2 max-w-[520px] text-mgm-txt-sm font-normal text-foreground-default"
        >
          {{ $t('relationsLayout.emptyState.description') }}
        </p>
      </template>
    </BaseEmptyState>

    <div
      class="mt-8 rounded-xl border border-border-subtle bg-background-subtle px-4 py-5 md:px-6 md:py-6"
    >
      <h4 class="text-mgm-txt-sm font-semibold text-foreground-emphasis">
        {{ $t('relationsLayout.emptyState.next.title') }}
      </h4>

      <ol class="mt-5 grid gap-5 md:grid-cols-3 md:gap-6">
        <li class="flex min-w-0 gap-3 md:block">
          <span
            class="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-background-brand-default-hover text-foreground-brand-default md:mb-3"
            aria-hidden="true"
          >
            <BaseIcon icon="message-circle" :size="18" />
          </span>
          <div>
            <p class="text-mgm-txt-sm font-medium text-foreground-emphasis">
              {{ $t('relationsLayout.emptyState.next.request.title') }}
            </p>
            <p class="mt-1 text-mgm-txt-xs text-foreground-default">
              {{ $t('relationsLayout.emptyState.next.request.description') }}
            </p>
          </div>
        </li>

        <li class="flex min-w-0 gap-3 md:block">
          <span
            class="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-background-brand-default-hover text-foreground-brand-default md:mb-3"
            aria-hidden="true"
          >
            <BaseIcon icon="mail" :size="18" />
          </span>
          <div>
            <p class="text-mgm-txt-sm font-medium text-foreground-emphasis">
              {{ $t('relationsLayout.emptyState.next.contact.title') }}
            </p>
            <p class="mt-1 text-mgm-txt-xs text-foreground-default">
              {{ $t('relationsLayout.emptyState.next.contact.description') }}
            </p>
          </div>
        </li>

        <li class="flex min-w-0 gap-3 md:block">
          <span
            class="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-background-brand-default-hover text-foreground-brand-default md:mb-3"
            aria-hidden="true"
          >
            <BaseIcon icon="check-circle" :size="18" />
          </span>
          <div>
            <p class="text-mgm-txt-sm font-medium text-foreground-emphasis">
              {{ $t('relationsLayout.emptyState.next.confirm.title') }}
            </p>
            <p class="mt-1 text-mgm-txt-xs text-foreground-default">
              {{ $t('relationsLayout.emptyState.next.confirm.description') }}
            </p>
          </div>
        </li>
      </ol>
    </div>
  </section>
</template>
